import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { filterToLabel } from '../types';
import FilterInput from './FilterInput';
import FilterChips from './FilterChips';
import { filterConfigs } from './filterConfig';
import { FilterSectionProps } from './types';

const FilterSection: FC<FilterSectionProps> = ({
  filterKey,
  values,
  newValue,
  options,
  onValueChange,
  onAdd,
  onRemove
}) => {
  const label = filterToLabel[filterKey];
  const config = filterConfigs[filterKey];

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 1, fontSize: '14px' }}>
        {label}
      </Typography>

      <FilterInput
        options={options}
        value={newValue}
        placeholder={config.placeholder}
        onValueChange={onValueChange}
        onAdd={onAdd}
        filterKey={filterKey}
      />

      <FilterChips filterKey={filterKey} values={values} onRemove={onRemove} />
    </Box>
  );
};

export default FilterSection;
